// extracted by mini-css-extract-plugin
export default {"content":"spHzEs","title":"PV1w5Y","subTitle":"aYvU9F","icon":"DQ6BFt"};